// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"26":"a377fd85","225":"87a9ee25","358":"1af62b8b","611":"478d735c","639":"915d2879","652":"8ea76933","659":"32d6cf79","853":"dfdaa5b8","948":"894f1c14"}[chunkId] + ".chunk.js";
};